import { useCallback } from "react";
import { sendEvent } from "../gtm/event";
import type { EventViewPromotionType } from "../types/event.type";

export const useEventViewPromotion = () => {
  const sendViewPromotionEvent = useCallback(
    (ecommerce: EventViewPromotionType["ecommerce"]) => {
      sendEvent({
        event: "view_promotion",
        ecommerce,
      });
    },
    [],
  );

  return { sendViewPromotionEvent };
};
